import { createFileRoute } from "@tanstack/react-router";
import { ProductPage } from "@/components/site/ProductPage";
import { MultifamilyCalculator } from "@/components/site/MultifamilyCalculator";
import { getProduct } from "@/data/products";
import { getProductHero } from "@/data/productHeroes";
import { buildHead } from "@/lib/seo-head";
import { LiveDscrRateSection } from "@/components/rates/LiveDscrRateSection";

const SLUG = "multifamily-loans";
const PRODUCT = getProduct(SLUG)!;
const HERO = getProductHero(SLUG);
const URL = `/${SLUG}`;

const KEYWORDS = [
  "multifamily loan",
  "5+ unit apartment loan",
  "commercial multifamily financing",
  "apartment building loan",
  "multifamily DSCR loan",
  "multifamily loan rates",
  "multifamily acquisition loan",
  "multifamily refinance loan",
  "NOI based multifamily loan",
  "multifamily loan LLC",
  "5-7-10 year fixed multifamily loan",
  "apartment building refinance",
].join(", ");

export const Route = createFileRoute("/multifamily-loans/")({
  head: () =>
    buildHead({
      title: "Multifamily Loans for 5+ Unit Apartment Buildings",
      description:
        "Commercial multifamily loans for 5+ unit apartments held in an LLC — sized off NOI, cap rate, and DSCR, with 5/7/10-year fixed terms.",
      url: URL,
      keywords: KEYWORDS,
      image: HERO?.src,
      imageAlt: HERO?.alt,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: PRODUCT.shortName, url: URL },
      ],
      service: { name: PRODUCT.name },
      faqs: PRODUCT.faq.map((f) => ({ q: f.q, a: f.a })),
    }),

  component: () => (
    <ProductPage
      product={PRODUCT}
      hideBaseTools
      topTools={
        <>
          <MultifamilyCalculator />
          <LiveDscrRateSection
            strategyCards
            id="live-rates"
            eyebrow={"Live pricing · DSCR"}
            heading={"Live DSCR pricing on a 1-4 unit rental scenario"}
            paragraphs={[
              "These are actual pricing responses returned for a sample business-purpose DSCR scenario on non-owner-occupied investment property - rate, APR, borrower points or lender credit, estimated principal and interest, and lock period from the same quote. Pricing changes intraday and is not a loan approval, commitment, or guarantee of financing.",
            ]}
            links={[
              { to: "/investment-property-rates", label: "Price your own DSCR scenario" },
              { to: "/rates", label: "See today's investor rate bands" },
            ]}
          />
        </>
      }

    />
  ),
});
